import type { HexAddress } from '../types'

/** Reserva nativa por defecto en mainnet / creative. */
export const DEFAULT_NATIVE_GAS_RESERVE = '0.00000001'

/** Reserva nativa en testnet. */
export const TESTNET_NATIVE_GAS_RESERVE = '0.00000001'

export const STUB_EXPLORER_BASE = 'https://example.invalid'
